import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';

const Button = styled(motion.button)`
  display: inline-block;
  font-family: ${props => props.theme.fonts.subheading};
  font-weight: ${props => props.theme.fontWeights.medium};
  padding: 0.875rem 1.75rem;
  border-radius: ${props => props.theme.borderRadius.medium};
  border: 2px solid transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1rem;
  text-align: center;
  line-height: 1;
  outline: none;
  position: relative;
  
  &:focus-visible {
    outline: 3px solid ${props => props.theme.colors.primary};
    outline-offset: 2px;
  }
  
  ${props => props.primary && css`
    background-color: ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.white};
    
    &:hover {
      background-color: ${props => props.theme.colors.white};
      border: 2px solid ${props => props.theme.colors.primary};
      color: ${props => props.theme.colors.primary};
    }
  `}
  
  ${props => props.secondary && css`
    background-color: transparent;
    color: ${props => props.theme.colors.white};
    border: 2px solid ${props => props.theme.colors.primary};
    
    &:hover {
      background-color: ${props => props.theme.colors.primary};
      color: ${props => props.theme.colors.white};
    }
  `}

  ${props => props.inverted && css`
    background-color: ${props => props.theme.colors.white};
    color: ${props => props.theme.colors.primary};
    border: 2px solid ${props => props.theme.colors.white};

    &:hover {
      background-color: ${props => props.theme.colors.grayLight};
      border-color: ${props => props.theme.colors.grayLight};
    }
  `}

  ${props => props.tertiary && css`
    background-color: ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.white};
    border: 2px solid ${props => props.theme.colors.white};

    &:hover {
      background-color: ${props => props.theme.colors.grayLight};
      border-color: ${props => props.theme.colors.primary};
      color: ${props => props.theme.colors.primary};
    }
  `}
  
  ${props => props.fullWidth && css`
    width: 100%;
  `}
  
  ${props => props.size === 'lg' && css`
    font-size: 1.125rem;
    padding: 1rem 2rem;
    border-radius: ${props => props.theme.borderRadius.large};
  `}
`;

export default Button;
